var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoHr = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3E3A01E8-DB88-4F03-9EF8-2BFAF2F542A7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wiki",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "12-wiki-Details",
    transform: "translate(-120.000000, -457.000000)",
    fill: "#191919",
    fillRule: "nonzero",
    stroke: "#191919",
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "main-topic",
    transform: "translate(100.000000, 126.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Marketing",
    transform: "translate(0.000000, 310.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico-Human-Resource-",
    transform: "translate(21.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05_head_hunting"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_HRsupport"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7747647,18.9854 L20.7665294,16.9146353 L19.2100588,16.0194588 L19.2100588,15.6949882 L19.824,15.0810471 C19.824,12.9353412 18.2720588,11.2005765 16.1263529,11.2005765 L15.939,11.2005765 C13.7932941,11.2005765 12.2409412,12.9353412 12.2409412,15.0810471 L12.887,15.7266941 L12.8972941,15.9951647 L11.298,16.9146353 L11.2897647,18.9854 L13.0611765,20.1947529 L13.2670588,20.1947529 L13.2670588,14.9072824 C13.2670588,13.4339882 14.4657059,12.2349294 15.939,12.2349294 L16.1263529,12.2349294 C17.5996471,12.2349294 18.7982941,13.4339882 18.7982941,14.9072824 L18.7982941,20.1947529 L19.0037647,20.1947529 L19.0041765,20.1947529 L19.0074706,20.1947529 L19.0074706,20.6761059 L14.5637059,20.6761059 L14.5637059,21.5996941 L19.9372353,21.5996941 L19.9372353,19.5573412 L20.7747647,18.9854 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1757,1.11283529 C8.86311176,1.11283529 10.2355235,2.48524706 10.2355235,4.17265882 C10.2355235,5.85965882 8.86311176,7.23207059 7.1757,7.23207059 C5.48828824,7.23207059 4.11587647,5.85965882 4.11587647,4.17265882 C4.11587647,2.48524706 5.48828824,1.11283529 7.1757,1.11283529 M7.1757,8.0556 C9.31687647,8.0556 11.0590529,6.31383529 11.0590529,4.17265882 C11.0590529,2.03107059 9.31687647,0.289305882 7.1757,0.289305882 C5.03452353,0.289305882 3.29234706,2.03107059 3.29234706,4.17265882 C3.29234706,6.31383529 5.03452353,8.0556 7.1757,8.0556",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3182588,10.8033882 C11.7366118,10.8033882 12.1323176,10.9862118 12.4032588,11.3053294 L13.0303765,10.7720941 C12.6029647,10.2685059 11.9787294,9.97985882 11.3182588,9.97985882 L3.02861176,9.97985882 C2.06178824,9.97985882 1.20737647,10.5966824 0.902670588,11.5145059 L0.162729412,17.8878 L0.980905882,17.9816824 L1.69737647,11.7360353 C1.90078824,11.1764471 2.43072941,10.8033882 3.02861176,10.8033882 L7.03343529,10.8033882 L6.33755294,11.8435059 L6.33755294,16.9016235 L7.17549412,17.7251529 L8.01384706,16.9016235 L8.01384706,11.8435059 L7.31796471,10.8033882 L11.3182588,10.8033882 Z",
    id: "Fill-5"
  }))))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoHr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_hr.a8ebdd1a9e06a87105355a31d236d3cf.svg";